import { useNavigate } from 'react-router-dom'

import { destroy } from '../../services/api'
import { Destroy } from 'components/Buttons/Destroy'

export function DestroyButton({ id }: { id: number }) {
  const navigate = useNavigate()

  return (
    <Destroy
      id={id}
      destroy={destroy}
      successMessage="Plano excluído com sucesso"
      onDestroy={() => navigate('/plans')}
    />
  )
}
